<template>
  <v-card :disabled="loading" :loading="loading">
    <v-card-title>
      <h2>{{ $t("menu.config_master_reg_curriculum") }}</h2>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="level_tab" @change="(e) => change_level(e)">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text>
              <v-autocomplete
                v-model="selected_faculties[i]"
                v-bind:label="$t('officer_config.faculty')"
                v-bind:items="registrar_faculties"
                v-bind:item-value="(item) => item.FACULTY_ID"
                v-bind:item-text="
                  (item) => objectTranslator(item, 'FACULTY_NAME')
                "
                outlined
              ></v-autocomplete>

              <div class="mb-3">
                <v-btn
                  color="blue"
                  dark
                  v-if="!edit_mode"
                  @click="enableEditInter()"
                  >Edit Inter</v-btn
                >
                <v-btn
                  color="green"
                  dark
                  v-if="edit_mode"
                  @click="saveEditInter()"
                  >Save</v-btn
                >
                <v-btn
                  color="red"
                  dark
                  class="ml-2"
                  v-if="edit_mode"
                  @click="cancelEditInter()"
                  >Cancel</v-btn
                >
              </div>

              <v-data-table
                :headers="headers"
                :items="
                  curriculums_by_level_and_faculty(
                    level.LEVEL_ID,
                    selected_faculties[i]
                  )
                "
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:item.INTER="{ item }">
                  <span>
                    <v-checkbox
                      v-if="edit_mode"
                      v-model="item.isInter"
                    ></v-checkbox>
                    <div v-if="!edit_mode">
                      <v-chip
                        v-if="item.INTER === '1'"
                        small
                        dark
                        color="deep-orange"
                      >
                        inter
                      </v-chip>

                      <v-chip v-if="item.INTER === '0'" small dark color="blue">
                        Thai
                      </v-chip>
                    </div>
                  </span>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editInfo(item)">
                    mdi-pencil
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-dialog v-model="edit_dialog" max-width="600">
      <v-card v-if="editing_curriculum">
        <v-card-title>
          Edit :
          <span v-if="editing_curriculum.LEVEL_ID == '1'">
            {{ objectTranslator(editing_curriculum, "SHORT_NAME") }}
          </span>
          <span v-else>
            {{ objectTranslator(editing_curriculum, "FULL_NAME") }}
          </span>
        </v-card-title>
        <v-card-text>
          <h3 class="deep-orange--text">
            <span v-if="editing_curriculum.LEVEL_ID == '1'">
              {{ editing_curriculum.SHORT_NAME_TH }}
            </span>
            <span v-else>
              {{ editing_curriculum.FULL_NAME_TH }}
            </span>
          </h3>
          <h3 class="brown--text">
            <span v-if="editing_curriculum.LEVEL_ID == '1'">
              {{ editing_curriculum.SHORT_NAME_EN }}
            </span>
            <span v-else>
              {{ editing_curriculum.FULL_NAME_EN }}
            </span>
          </h3>
          <v-text-field
            class="mt-5"
            :label="$t('officer_config.tcas_program_id')"
            outlined
            dense
            v-model="editing_curriculum_tcas_program_id"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green" dark elevation="0" @click="saveInfo()"
            >Save</v-btn
          >
          <v-btn
            color="red"
            dark
            elevation="0"
            class="ml-2"
            @click="edit_dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  objectTranslator,
  dateFromDBTranslator as dt,
} from "@/helper/translator";
import FacultyProvider from "@/services/faculty.provider";
const facultyService = new FacultyProvider();

export default {
  name: "ConfigMasterRegCurriculum",
  data: () => ({
    edit_dialog: false,
    loading: false,
    level_tab: null,
    registrar_faculties: [],
    master_reg_curriculums: [],

    editing_curriculum: null,
    editing_curriculum_tcas_program_id: null,
    edit_mode: false,

    selected_faculties: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: "Curriculum",
          align: "start",
          sortable: true,
          value:
            (this.level_tab == 0
              ? "SHORT_NAME_"
              : "FULL_NAME_") + String(this.$root.$i18n.locale).toUpperCase(),
        },
        {
          text: "TCAS ID",
          align: "start",
          sortable: true,
          value: "TCAS_PROGRAM_ID",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
        {
          text: "INTER",
          align: "start",
          sortable: true,
          value: "INTER",
        },
      ];
    },
    levels() {
      return this.$store.state.ref.levels;
    },
  },
  methods: {
    objectTranslator,
    dt,
    enableEditInter() {
      this.reset_isInter();
      this.edit_mode = true;
    },
    async saveEditInter() {
      this.loading = true;
      let all_response = true;
      const all_change = this.master_reg_curriculums.filter(
        (item) => item.isInter !== (item.INTER === "1")
      );
      for (const item of all_change) {
        const response = await facultyService
          .setCurriculumInter(item.CURRICULUM_ID, item.isInter)
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
          });
        if (response) all_response = all_response && response.status;
      }

      if (all_response) {
        this.$toasted.success(this.$t("toasted.edit_successfully"));
        this.edit_dialog = false;
      } else {
        this.$toasted.error(this.$t("toasted.cannot_edit"));
      }

      await this.fetch_curriculums();
      this.edit_mode = false;
      this.loading = false;
    },
    reset_isInter() {
      this.master_reg_curriculums = this.master_reg_curriculums.map((item) => {
        item.isInter = item.INTER === "1";
        return item;
      });
    },
    cancelEditInter() {
      this.reset_isInter();
      this.edit_mode = false;
    },
    editInfo(item) {
      this.editing_curriculum = item;
      this.editing_curriculum_tcas_program_id = item.TCAS_PROGRAM_ID;
      this.edit_dialog = true;
    },
    async saveInfo() {
      this.loading = true;
      const response = await facultyService
        .setCurriculumTcasId(
          this.editing_curriculum.CURRICULUM_ID,
          this.editing_curriculum_tcas_program_id
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });
      if (response) {
        if (response.status) {
          this.$toasted.success(this.$t("toasted.edit_successfully"));
          this.edit_dialog = false;
        } else {
          this.$toasted.error(this.$t("toasted.cannot_edit"));
        }
      }
      await this.fetch_curriculums();
      this.loading = false;
    },
    curriculums_by_level_and_faculty(level_id, faculty_id) {
      return this.master_reg_curriculums.filter(
        (curr) => curr.FACULTY_ID === faculty_id && curr.LEVEL_ID === level_id
      );
    },
    async fetch_faculty() {
      this.loading = true;
      const faculties = await facultyService.getFaculties();
      this.registrar_faculties = faculties;
      this.loading = false;
    },
    async fetch_curriculums() {
      this.loading = true;
      let all_curriculums = [];
      for (const level of this.levels) {
        let curriculums = await facultyService.getCurriculums(level.LEVEL_ID);
        for (let curr of curriculums) {
          curr.isInter = curr.INTER === "1";
        }
        all_curriculums = all_curriculums.concat(curriculums);
      }
      this.master_reg_curriculums = all_curriculums;
      this.loading = false;
    },
    change_level() {
      this.cancelEditInter();
      if (this.master_reg_curriculums.length === 0) this.fetch_curriculums();
    },
    // async fetch_faculty_curriculum(level_id) {
    //   this.toggle_loading(true);
    //   if (this.registrar_faculties.length == 0) {
    //     const faculties = await facultyService.getFaculties();
    //     this.registrar_faculties = faculties;
    //     const curriculums = await facultyService.getCurriculums(level_id);
    //     this.registrar_curriculums = curriculums;
    //   }
    //   if (this.branczhes.length == 0) {
    //     const branches = await configService.getBranches();
    //     this.branches = branches;
    //   }
    //   this.toggle_loading(false);
    // },
  },
  created: function () {
    this.fetch_faculty();
    this.$store.dispatch("ref/getLevels");
  },
};
</script>
